import { FC, useCallback, useMemo, memo } from 'react';

import { Cell, CellRightLabel, CellText, Card, Badge } from '@hh.ru/magritte-ui';

import FilterCount from 'src/components/Search/Common/Filters/FilterCount';
import MetroIcon from 'src/components/Search/Common/Metro/MetroIcon';
import { ModelDataMetro } from 'src/components/Search/Common/Metro/types';
import { useSelector } from 'src/hooks/useSelector';
import { EMPTY_CLUSTER } from 'src/models/search/common/clusters';
import { ClusterKey } from 'src/types/search/common/clusters';

interface LineItemProps {
    id: string;
    text: string;
    allItems: ModelDataMetro[];
    isChecked?: boolean;
    color: string;
    onClick: (id: string) => void;
}

/**
 * Кликабельная карточка линии, открывающая вложенные станции метро.
 */
const LineItem: FC<LineItemProps> = ({ id, text, allItems, isChecked, color, onClick }) => {
    const { groups: metroGroups, selectedValues: selectedMetro } = useSelector(
        (state) => state.searchDraftClusters[ClusterKey.Metro] || EMPTY_CLUSTER
    );

    const [resumeCounter, selectedMetroCounter] = useMemo(() => {
        let resumeCounter = 0;
        let selectedMetroCounter = isChecked ? allItems?.length : 0;

        allItems?.forEach((item) => {
            resumeCounter += metroGroups[item.id]?.count || 0;

            if (!isChecked && selectedMetro.includes(item.id)) {
                selectedMetroCounter += 1;
            }
        });

        return [resumeCounter, selectedMetroCounter];
    }, [isChecked, allItems, metroGroups, selectedMetro]);

    const handleClick = useCallback(() => {
        onClick(id);
    }, [id, onClick]);

    return (
        <Card
            onClick={handleClick}
            borderStyle="neutral"
            borderWidth="default"
            padding={16}
            borderRadius={12}
            stretched
        >
            <Cell
                left={<MetroIcon isLine color={color} />}
                right={
                    <CellRightLabel
                        badge={
                            selectedMetroCounter ? (
                                <Badge style="accent" data-qa="line-selected-items-counter">
                                    {String(selectedMetroCounter)}
                                </Badge>
                            ) : null
                        }
                    >
                        {!selectedMetroCounter ? <FilterCount count={resumeCounter || 0} /> : ''}
                    </CellRightLabel>
                }
            >
                <CellText>{text}</CellText>
            </Cell>
        </Card>
    );
};

export default memo(LineItem);
